<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M7.5013 8.33463C9.34225 8.33463 10.8346 6.84225 10.8346 5.0013C10.8346 3.16035 9.34225 1.66797 7.5013 1.66797C5.66035 1.66797 4.16797 3.16035 4.16797 5.0013C4.16797 6.84225 5.66035 8.33463 7.5013 8.33463Z"
      fill="currentColor"
    />
    <path
      d="M7.5013 17.5026C10.723 17.5026 13.3346 16.0102 13.3346 14.1693C13.3346 12.3283 10.723 10.8359 7.5013 10.8359C4.27964 10.8359 1.66797 12.3283 1.66797 14.1693C1.66797 16.0102 4.27964 17.5026 7.5013 17.5026Z"
      fill="currentColor"
    />
    <path
      d="M17.5 14.168C17.5 15.5486 15.8037 16.6679 13.7326 16.6679C14.3428 16.001 14.7624 15.1638 14.7624 14.1691C14.7624 13.1732 14.3418 12.3353 13.7305 11.668C15.8016 11.668 17.5 12.7872 17.5 14.168Z"
      fill="currentColor"
    />
    <path
      d="M15.0015 5C15.0015 6.38072 13.8823 7.5 12.5015 7.5C12.2004 7.5 11.9119 7.44678 11.6445 7.34923C12.0388 6.65582 12.2639 5.85374 12.2639 4.99907C12.2639 4.14503 12.0391 3.34351 11.6454 2.65045C11.9124 2.55311 12.2008 2.5 12.5015 2.5C13.8823 2.5 15.0015 3.61929 15.0015 5Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'TaxpayersIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>